"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.5 17H23v-.5c0-1.93-1.57-3.5-3.5-3.5S16 14.57 16 16.5v.5h-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm-6.5-.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5v.5h-5v-.5ZM20.5 0a.5.5 0 0 1 .492.41L21 .5v7.793l2.854 2.854a.499.499 0 0 1-.269.846L23.5 12h-3a.5.5 0 0 1-.09-.992L20.5 11h1.793l-2.146-2.146a.501.501 0 0 1-.14-.275L20 8.5V1h-3v3.5a.5.5 0 0 1-.788.41l-.066-.056-3.647-3.647a.732.732 0 0 0-.913-.071l-.085.071L1.707 11H3.5a.5.5 0 0 1 .492.41L4 11.5V23h9.5a.5.5 0 0 1 .09.992L13.5 24h-10a.5.5 0 0 1-.492-.41L3 23.5V12H.5a.5.5 0 0 1-.409-.789l.055-.065L10.794.5c.6-.603 1.642-.637 2.294-.106l.118.106L16 3.293V.5a.5.5 0 0 1 .41-.492L16.5 0h4ZM23 18v5h-7v-5h7Zm-3.5 1a1 1 0 0 0-1 1c0 .366.206.673.5.847v.653a.5.5 0 0 0 1 0v-.653a.985.985 0 0 0 .5-.847 1 1 0 0 0-1-1Zm-4-7a.5.5 0 0 1 .492.41l.008.09v1a.5.5 0 0 1-.992.09L15 13.5V13H9v6h4.5a.5.5 0 0 1 .09.992L13.5 20h-5a.5.5 0 0 1-.492-.41L8 19.5v-7a.5.5 0 0 1 .41-.492L8.5 12h7Z",
    clipRule: "evenodd"
  })]
});